import { curry, mapKeys, getOr } from 'lodash/fp';
export var mapKeysTemplate = curry(function (template, obj) {
  return mapKeys(function (key) {
    return getOr(key, key, template);
  }, obj);
});
export default mapKeysTemplate;